import { _patientUrls } from '@custom/Utils/constants/apiUrls';
import { createAsyncThunk } from '@reduxjs/toolkit';


const prescriptionList = createAsyncThunk('prescriptionList', async (body:any) => {
  try {
    let url = _patientUrls.prescriptionList//`${GET_USERLIST}?limit=10&offset=0&search=&hospitalId=0395fb0deeee156e2854414d6900e8a8`
    const token = sessionStorage.getItem('token') || localStorage.getItem('token');
    let response = await fetch(url, {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      body:JSON.stringify(body)
    })
    return await response.json()
  } catch (error) {
    return error;
  }
});

export default prescriptionList;
